import { Injectable } from '@angular/core';


@Injectable()
export class PrimeUtilServices {
    constructor() {}
}
